export const roles = {
  DIRECTOR: 'director',
  CO_DIRECTOR: 'co-director',
  PRODUCER: 'producer',
  EXECUTIVE_PRODUCER: 'executive-producer',
  CO_PRODUCER: 'co-producer',
  ASSOCIATE_PRODUCER: 'associate-producer',
  COLLABORATING_DIRECTOR: 'collaborating-director',
  PRODUCTION_MANAGER: 'production-manager',
  PRODUCTION_COORDINATOR: 'production-coordinator',
  PRODUCTION_ASSISTANT: 'production-assistant',
  ASSISTANT_DIRECTOR: 'assistant-director',
  '2ND_ASSISTANT_DIRECTOR': '2nd-assistant-director',
  SCRIPT_SUPERVISOR: 'script-supervisor',
  LOCATION_MANAGER: 'location-manager',
  WRITER: 'writer',
  CO_WRITER: 'co-writer',
  STORY: 'story',
  ADAPTATION: 'adaptation',
  AUTHOR_OF_ADAPTED_MATERIAL: 'author-of-adapted-material',
  CINEMATOGRAPHER_DP: 'cinematographer-dp',
  ASSISTANT_CAMERA: 'assistant-camera',
  ADDITIONAL_PHOTOGRAPHY: 'additional-photography',
  '2ND_UNIT_DIR_OF_PHOTOGRAPHY': '2nd-unit-dir-of-photography',
  CAMERA_OPERATOR: 'camera-operator',
  GAFFER: 'gaffer',
  BEST_BOY: 'best-boy',
  KEY_GRIP: 'key-grip',
  ADDITIONAL_GRIP: 'additional-grip',
  DOLLY_GRIP: 'dolly-grip',
  GRIP: 'grip',
  SOUND_MIXER: 'sound-mixer',
  BOOM_OPERATOR: 'boom-operator',
  CABLE_PERSON: 'cable-person',
  VIDEO_OPERATOR: 'video-operator',
  ART_DIRECTOR: 'art-director',
  ASSISTANT_ART_DIRECTOR: 'assistant-art-director',
  COSTUME_DESIGNER: 'costume-designer',
  COSTUMER: 'costumer',
  HAIRSTYLIST: 'hairstylist',
  LEAD_PERSON: 'lead-person',
  MAKEUP_ARTIST: 'makeup-artist',
  MAKEUP_EFFECTS: 'makeup-effects',
  PRODUCTION_DESIGNER: 'production-designer',
  PROPERTY_MASTER: 'property-master',
  SET_DECORATOR: 'set decorator',
  SET_DESIGNER: 'set-designer',
  SWING_GANG: 'swing-gang',
  ANIMAL_TRAINER: 'animal-trainer',
  CHOREOGRAPHER: 'choreographer',
  SPECIAL_EFFECTS: 'special-effects',
  STUNT_COORDINATOR: 'stunt-coordinator',
  TECHNICAL_ADVISOR: 'technical-advisor',
  EDITOR: 'editor',
  ASSISTANT_EDITOR: 'assistant-editor',
  SOUND_EDITOR: 'sound-editor',
  DIGITAL_EFFECTS: 'digital-effects',
  ORIGINAL_MUSIC_COMPOSER: 'original-music-composer',
  ANIMATOR: 'animator',
  AGENT: 'agent',
  MANAGER: 'manager',
  PUBLICIST: 'publicist',
  PRINT_SHIPPER: 'print-shipper',
  PRINT_RETURN: 'print-return',
  PREVIEW_RETURN: 'preview-return',
  ACADEMIC_ADVISOR: 'academic-advisor',
  SCHOOL_ADMINISTRATOR: 'school-administrator',
};

export const categories = {
  POPULAR: 'popular',
  PRODUCTION: 'production',
  WRITING: 'writing',
  CAMERA: 'camera',
  ELECTRICS: 'electrics',
  GRIP: 'grip',
  SOUND_AND_VIDEO: 'sound_and_video',
  ART: 'art',
  SPECIALIZED: 'specialized',
  POST_PRODUCTION: 'post_production',
  ANIMATION: 'animation',
  REPRESENTATION: 'representation',
  PRINT_TRAFFIC: 'print_traffic',
  ACADEMIC: 'academic',
};


export default _.values(roles);


export const categoryValues = {
  [categories.POPULAR]: [
    roles.DIRECTOR,
    roles.CO_DIRECTOR,
    roles.PRODUCER,
    roles.EXECUTIVE_PRODUCER,
    roles.CO_PRODUCER,
    roles.ASSOCIATE_PRODUCER,
    roles.COLLABORATING_DIRECTOR,
    roles.ART_DIRECTOR,
    roles.ASSISTANT_DIRECTOR,
    roles.ASSISTANT_CAMERA,
    roles.CINEMATOGRAPHER_DP,
    roles.WRITER,
    roles.GAFFER,
    roles.SOUND_MIXER,
    roles.PRODUCTION_DESIGNER,
    roles.EDITOR,
    roles.AGENT,
    roles.MANAGER,
    roles.PUBLICIST,
  ],
  [categories.PRODUCTION]: [
    roles.DIRECTOR,
    roles.CO_DIRECTOR,
    roles.PRODUCER,
    roles.EXECUTIVE_PRODUCER,
    roles.CO_PRODUCER,
    roles.ASSOCIATE_PRODUCER,
    roles.COLLABORATING_DIRECTOR,
    roles.PRODUCTION_MANAGER,
    roles.PRODUCTION_COORDINATOR,
    roles.PRODUCTION_ASSISTANT,
    roles.ASSISTANT_DIRECTOR,
    roles['2ND_ASSISTANT_DIRECTOR'],
    roles.SCRIPT_SUPERVISOR,
    roles.LOCATION_MANAGER,
  ],
  [categories.WRITING]: [
    roles.WRITER,
    roles.CO_WRITER,
    roles.STORY,
    roles.ADAPTATION,
    roles.AUTHOR_OF_ADAPTED_MATERIAL,
  ],
  [categories.CAMERA]: [
    roles.CINEMATOGRAPHER_DP,
    roles.ASSISTANT_CAMERA,
    roles.ADDITIONAL_PHOTOGRAPHY,
    roles['2ND_UNIT_DIR_OF_PHOTOGRAPHY'],
    roles.CAMERA_OPERATOR,
  ],
  [categories.ELECTRICS]: [
    roles.GAFFER,
    roles.BEST_BOY,
  ],
  [categories.GRIP]: [
    roles.KEY_GRIP,
    roles.ADDITIONAL_GRIP,
    roles.DOLLY_GRIP,
    roles.GRIP,
  ],
  [categories.SOUND_AND_VIDEO]: [
    roles.SOUND_MIXER,
    roles.BOOM_OPERATOR,
    roles.CABLE_PERSON,
    roles.VIDEO_OPERATOR,
  ],
  [categories.ART]: [
    roles.ART_DIRECTOR,
    roles.ASSISTANT_ART_DIRECTOR,
    roles.COSTUME_DESIGNER,
    roles.COSTUMER,
    roles.HAIRSTYLIST,
    roles.LEAD_PERSON,
    roles.MAKEUP_ARTIST,
    roles.MAKEUP_EFFECTS,
    roles.PRODUCTION_DESIGNER,
    roles.PROPERTY_MASTER,
    roles.SET_DECORATOR,
    roles.SET_DESIGNER,
    roles.SWING_GANG,
  ],
  [categories.SPECIALIZED]: [
    roles.ANIMAL_TRAINER,
    roles.CHOREOGRAPHER,
    roles.SPECIAL_EFFECTS,
    roles.STUNT_COORDINATOR,
    roles.TECHNICAL_ADVISOR,
  ],
  [categories.POST_PRODUCTION]: [
    roles.EDITOR,
    roles.ASSISTANT_EDITOR,
    roles.SOUND_EDITOR,
    roles.DIGITAL_EFFECTS,
    roles.ORIGINAL_MUSIC_COMPOSER,
  ],
  [categories.ANIMATION]: [
    roles.ANIMATOR,
  ],
  [categories.REPRESENTATION]: [
    roles.AGENT,
    roles.MANAGER,
    roles.PUBLICIST,
  ],
  [categories.PRINT_TRAFFIC]: [
    roles.PRINT_SHIPPER,
    roles.PRINT_RETURN,
    roles.PREVIEW_RETURN,
  ],
  [categories.ACADEMIC]: [
    roles.ACADEMIC_ADVISOR,
    roles.SCHOOL_ADMINISTRATOR,
  ],
};



// WEBPACK FOOTER //
// ./src/shared/constants/crew.js